import { Tooltip } from "antd";
import {
  RobotOutlined,
  ApiOutlined,
  ThunderboltOutlined,
  FileTextOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "@/stores/auth";
import { UserAvatar } from "@/components/UserAvatar";
import { UserCard } from "@/components/UserCard";
import styles from "./toolbar.module.css";

interface ToolbarItem {
  key: string;
  icon: React.ReactNode;
  label: string;
  path: string;
}

export function Toolbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuthStore();

  const items: ToolbarItem[] = [
    { key: "agents", icon: <RobotOutlined />, label: t("toolbar.agents"), path: "/agents" },
    { key: "mcps", icon: <ApiOutlined />, label: t("toolbar.mcps"), path: "/mcps" },
    { key: "skills", icon: <ThunderboltOutlined />, label: t("toolbar.skills"), path: "/skills" },
    { key: "documents", icon: <FileTextOutlined />, label: t("toolbar.documents"), path: "/documents" },
    { key: "management", icon: <SettingOutlined />, label: t("toolbar.management"), path: "/management" },
  ];

  const activeKey = items.find((item) => location.pathname.startsWith(item.path))?.key;

  return (
    <div className={styles.toolbar}>
      <div className={styles.logo}>
        <img src="/brand-128.png" alt="logo" className={styles.logoImg} />
      </div>

      <div className={styles.items}>
        {items.map((item) => (
          <Tooltip key={item.key} title={item.label} placement="right">
            <div
              className={`${styles.item} ${activeKey === item.key ? styles.active : ""}`}
              onClick={() => navigate(item.path)}
            >
              {item.icon}
            </div>
          </Tooltip>
        ))}
      </div>

      <div className={styles.bottom}>
        {user && (
          <UserCard>
            <div style={{ cursor: "pointer" }}>
              <UserAvatar name={user.name} avatar={user.avatar} size={32} />
            </div>
          </UserCard>
        )}
      </div>
    </div>
  );
}
